import {
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { useExtendsionFormPartD } from "components/smart-visa-extension/useExtendsionForm";
import { EXTENSION_DOCUMENT_STEP } from "libs/configs/constant";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";

export default function PartC() {
  const classes = useStyles();
  const { formik, onSaveDraft } = useExtendsionFormPartD();

  const masterData = useSelector(selectMasterData);

  const organiztionTypeConfig = get(masterData, "organiztionTypeConfig", []);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={0} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part D : Data of the employer or sponsor in Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>Organization Name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="OrganiztionName"
                        value={formik.values.OrganiztionName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrganiztionName", formik)}
                        helperText={getErrorMessage("OrganiztionName", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>Address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="OrganiztionAddress"
                        value={formik.values.OrganiztionAddress}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrganiztionAddress", formik)}
                        helperText={getErrorMessage(
                          "OrganiztionAddress",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    className={classes.cellContent}
                    style={{ marginTop: -75 }}
                  >
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>Phone number</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="OrganiztionPhone"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.OrganiztionPhone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrganiztionPhone", formik)}
                        helperText={getErrorMessage("OrganiztionPhone", formik)}
                        // type="number"
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>Type of Organization</InputLabel>
                      <FormGroup row>
                        {organiztionTypeConfig.map((organiztionType) => (
                          <FormControlLabel
                            key={organiztionType.organiztionTypeConfigID}
                            control={
                              <StyleCheckbox
                                name={organiztionType.organiztionTypeConfigName}
                                value={organiztionType.organiztionTypeConfigID}
                                checked={
                                  formik.values.OrganiztionType ===
                                  organiztionType.organiztionTypeConfigID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "OrganiztionType",
                                    organiztionType.organiztionTypeConfigID
                                  );
                                }}
                              />
                            }
                            label={organiztionType.organiztionTypeConfigName}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>A reference person’s name</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="RefernceName"
                        value={formik.values.RefernceName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("RefernceName", formik)}
                        helperText={getErrorMessage("RefernceName", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>A reference person’s position</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ReferncePosition"
                        value={formik.values.ReferncePosition}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ReferncePosition", formik)}
                        helperText={getErrorMessage("ReferncePosition", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="RefernceEmail"
                        value={formik.values.RefernceEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("RefernceEmail", formik)}
                        helperText={getErrorMessage("RefernceEmail", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Mobile phone number</InputLabel>
                      <TextField
                        variant="outlined"
                        // type="number"
                        className={classes.textField}
                        name="RefernceMobile"
                        inputProps={{ maxLength: 10 }}
                        onKeyDown={(e) => {
                          const pattern = /[^0-9]/g;
                          const isNotAllow =
                            e.key.length === 1 && pattern.test(e.key);

                          if (isNotAllow) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.RefernceMobile}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("RefernceMobile", formik)}
                        helperText={getErrorMessage("RefernceMobile", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
